import React, { Component } from 'react';
import { bindActionCreators, Dispatch } from 'redux';

import { activeMenu, handleGettingStartedData, hideSortingMenu, setExceptionHandler } from '@app/store/actions';
import { connect } from 'react-redux';
import { mainMenuTypes, IMenuItem } from '@app/components/Sidebar/menuObject';
import { getMenuItemById } from '@app/helpers';
import WantHelp from './components/wantHelp.component';
import TrialDaysRemaining from './components/trialDaysRemaining.component';
import Checklist from './components/checklist.component';

import { WithTranslation, withTranslation } from 'react-i18next';
import { IWelcomeStep, IStepCategory, ITrialDaysRemaining } from '@app/models';
import { gettingStartedService } from '@app/services';
import { Infobox } from '@app/components';
import { VerifiedUser } from '@material-ui/icons';

interface IProps extends WithTranslation {
    welcomeSteps: IWelcomeStep[];
    trialDaysRemaining: ITrialDaysRemaining;
    actions: {
        hideSortingMenu: Function;
        activeMenu: Function;
        handleGettingStartedData: Function;
        setExceptionHandler: Function;
    };
}

interface IState {
    menuItem: IMenuItem;
}

class GettingStartedPage extends Component<IProps, IState> {

    componentWillMount() {
        this.setMenuItem();
        this.props.actions.hideSortingMenu();
    }

    componentDidMount() {
        this.props.actions.activeMenu(this.state.menuItem.id);
        this.props.actions.handleGettingStartedData();
        this.props.actions.setExceptionHandler(true);
    }

    render() {

        const { welcomeSteps, trialDaysRemaining, t: translation } = this.props;
        const sortedSteps: IStepCategory[] = gettingStartedService.sortedSteps(welcomeSteps);

        return (
            <div className='container--row'>
                <main className='content'>
                    <h1 className='header--h1'>{translation('GS_HEADER_TITLE')}</h1>
                    <Infobox
                        text={'GS_HEADER_TEXT'}
                        icon={<VerifiedUser />}
                    />
                    <Checklist steps={sortedSteps} />
                </main>
                <aside className='information'>
                    {trialDaysRemaining && trialDaysRemaining.State === 'Trial' &&
                        <TrialDaysRemaining trialDaysRemaining={trialDaysRemaining} />
                    }
                    <WantHelp />
                </aside>
            </div>
        );
    }

    private setMenuItem() {
        const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.GettingStarted);

        if (item !== undefined) {
            this.setState({
                menuItem: item
            });
        }
    }
}

const mapStateToProps = (state: any) => ({
    welcomeSteps: state.gettingStarted.steps,
    trialDaysRemaining: state.gettingStarted.trialDaysRemaining
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    actions: bindActionCreators(
        {
            activeMenu,
            handleGettingStartedData,
            hideSortingMenu,
            setExceptionHandler
        },
        dispatch
    )
});


export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GettingStartedPage));
